import { render, staticRenderFns } from "./MedLabelAll.vue?vue&type=template&id=c5a4011c&scoped=true&"
import script from "./MedLabelAll.vue?vue&type=script&lang=js&"
export * from "./MedLabelAll.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=c5a4011c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a4011c",
  null
  
)

export default component.exports